'use client';

import './business.css';

import BusinessConsultTimeline from '@/components/BusinessConsultTimeline';
import Data4 from '../../../textContent/servicesHeroContent/Business';
import { Fragment } from 'react';
import Rocket from '../../../components/Rocket';
import ServicesHero from '@/components/ServicesHero';
import { motion } from 'framer-motion';
import rocket3 from '../../../textContent/rocket/rocket3.json';

const Page = () => {
    return (
        <Fragment>
            {/* Hero Section */}
            <motion.div
                initial={{ opacity: 0, y: -40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, ease: 'easeOut' }}
            >
                <ServicesHero data={Data4} />
            </motion.div>

            {/* Mission Section */}
            <div
                id="ourmission"
                className="md:flex md:w-full md:py-[5vw] md:pl-[10vw]"
            >
                {/* Left Mission */}
                <motion.div
                    id="leftmission"
                    className="md:p-[0vw] p-[8vw] md:max-w-[40%]"
                    initial={{ opacity: 0, x: -40 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true, amount: 0.2 }}
                    transition={{ duration: 0.8, ease: 'easeOut' }}
                >
                    <p className="text-blue-700 font-semibold md:text-xs text-lg uppercase tracking-widest">
                        Mission
                    </p>

                    <p className="md:text-4xl text-3xl font-extrabold md:mt-2 mt-[4vw] text-[#292D34] tracking-wider">
                        Feeling overwhelmed by accounting headaches ?
                    </p>

                    <div className="border-2 border-blue-500 rounded-3xl md:w-[5vw] w-[22vw] md:mt-[1vw] mt-[3vw]" />

                    <p className="md:mt-4 mt-[12vw] opacity-60">
                        You&apos;re not alone. At Wahni IT Solutions, we
                        understand the challenges businesses face in navigating
                        the ever-changing financial landscape. That&apos;s why
                        we offer a comprehensive suite of services to streamline
                        your operations, optimize your finances, and ensure your
                        compliance.
                    </p>
                </motion.div>

                {/* Right Mission */}
                <motion.div
                    id="rightmission"
                    className="md:w-[50%] md:flex items-center justify-center"
                    initial={{ opacity: 0, scale: 0.9 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true, amount: 0.2 }}
                    transition={{ duration: 0.7, ease: 'easeOut' }}
                >
                    <p className="text-4xl md:text-5xl font-bold bg-white rounded-2xl p-10 shadow-2xl hover:scale-105 transition duration-500 text-center md:text-left">
                        Improve <br />
                        <span className="text-purple-600 font-extrabold">
                            financial
                        </span>
                        <br />
                        accuracy <br />
                        and <br />
                        <span className="text-purple-600 font-extrabold">
                            transparency
                        </span>
                    </p>
                </motion.div>
            </div>

            {/* Timeline Section */}
            <div
                id="timeline"
                className="flex flex-col items-center justify-center px-5"
            >
                <motion.p
                    className="md:text-4xl text-2xl font-bold md:pb-28 md:pt-0 pt-20 pb-10 text-center"
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.2 }}
                    transition={{ duration: 0.7 }}
                >
                    Unveiling our blueprint for <br /> successful ERP
                    implementation.
                </motion.p>

                <motion.div
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true, amount: 0.2 }}
                    transition={{ duration: 0.8 }}
                >
                    <BusinessConsultTimeline />
                </motion.div>
            </div>

            {/* Rocket Section */}
            <motion.div
                id="iconss"
                className="flex items-center justify-center my-10"
                initial={{ opacity: 0, scale: 0.85 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.6, ease: 'easeOut' }}
            >
                <Rocket jsonData={rocket3} />
            </motion.div>
        </Fragment>
    );
};

export default Page;
